
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website, WebsiteComposite } from '@/services/Website/interfaces';

export interface DnsManageRecord {
  id: string | number;
  name: string;
  type: string;
  content: string;
  ttl: number;
}

export interface DnsManageData {
  zoneId?: string | number;
  records?: DnsManageRecord[];
  zoneError?: string;
}

@Component
export default class DnsManagePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  @Prop({ type: Object, default: () => ({}) })
  public panelData!: DnsManageData;

  public confirmRecordId: string | number | null = null;

  public confirmInput: string = '';

  public get website(): Website {
    return this.composite.website;
  }

  public get records(): DnsManageRecord[] {
    return (this.panelData && this.panelData.records) || [];
  }

  public get confirmValid(): boolean {
    return !!this.confirmRecordId
      && this.confirmInput.trim().toLowerCase() === this.website.domain.toLowerCase();
  }

  public startDelete(recordId: string | number): void {
    this.confirmRecordId = recordId;
    this.confirmInput = '';
  }

  public cancelDelete(): void {
    this.confirmRecordId = null;
    this.confirmInput = '';
  }

  public confirmDelete(): void {
    if (!this.confirmValid || this.confirmRecordId === null) {
      return;
    }
    const recordId = this.confirmRecordId;
    this.cancelDelete();
    this.emitSubmit('delete', { recordId });
  }

  public emitSubmit(operation: string, payload: Record<string, unknown> = {}): void {
    this.$emit('submit', { operation, ...payload });
  }
}
